import { render, staticRenderFns } from "./GlobalConfigCardTrimmingCost.vue?vue&type=template&id=7a809156&scoped=true"
import script from "./GlobalConfigCardTrimmingCost.vue?vue&type=script&lang=ts"
export * from "./GlobalConfigCardTrimmingCost.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a809156",
  null
  
)

export default component.exports